import BaseAPI, { recoverFromNotFound } from './BaseAPI';

export default class ScimAPI extends BaseAPI {
  @recoverFromNotFound()
  async findScimGroups(organizationId: string, query?: string) {
    const headers = {
      'TT-X-Organization-Key': organizationId,
    };
    const endpoint = `${this.host.tcUrl}/v1/user-service/Groups${
      query ? `?group_name=${query}` : ''
    }`;
    const res = await this.httpClient.get(endpoint, { headers });
    return res.data;
  }

  @recoverFromNotFound()
  async findScimGroup(id: string, organizationId: string) {
    const headers = {
      'TT-X-Organization-Key': organizationId,
    };
    const endpoint = `${this.host.tcUrl}/v1/user-service/Groups/${id}`;
    const res = await this.httpClient.get(endpoint, { headers });

    return res.data;
  }

  @recoverFromNotFound()
  async findSettings(organizationId: string) {
    const headers = { 'TT-X-Organization-Key': organizationId };
    const endpoint = `${this.host.tcUrl}/v1/user-service/SCIMConfiguration`;
    const res = await this.httpClient.get(endpoint, { headers });
    return res.data;
  }

  @recoverFromNotFound()
  async findBearerToken(organizationId: string) {
    const headers = { 'TT-X-Organization-Key': organizationId };
    const endpoint = `${this.host.tcUrl}/v1/user-service/BearerToken`;
    const res = await this.httpClient.get(endpoint, { headers });
    return res.data;
  }

  @recoverFromNotFound()
  async findScimUser(organizationId: string, userId: string) {
    const headers = { 'TT-X-Organization-Key': organizationId };
    const endpoint = `${this.host.tcUrl}/v1/user-service/Users/${userId}`;
    const res = await this.httpClient.get(endpoint, { headers });
    return res.data;
  }

  @recoverFromNotFound()
  async setupScim(params: {
    suffix?: string;
    prefix?: string;
    organizationId: string;
    clientName: string;
  }) {
    const { organizationId, ...data } = params;
    const headers = { 'TT-X-Organization-Key': organizationId };
    const endpoint = `${this.host.tcUrl}/v1/user-service/SetupSCIM`;
    const res = await this.httpClient.post(endpoint, {
      data,
      headers,
    });
    return res.data;
  }

  async findAvailableSCIMFields(organizationId: string) {
    const headers = { 'TT-X-Organization-Key': organizationId };
    const endpoint = `${this.host.tcUrl}/v1/user-service/AvailableSCIMFields`;
    const res = await this.httpClient.get(endpoint, { headers });
    return res.data;
  }

  async deleteScimUser(organizationId: string, userId: string) {
    const headers = { 'TT-X-Organization-Key': organizationId };
    const endpoint = `${this.host.tcUrl}/v1/user-service/Users/${userId}`;
    const res = await this.httpClient.del(endpoint, { headers });
    return res.data;
  }
}
